export const MY_SCHNEIDER_CLICK_EVENT = 'pesLinkClick';
